module.exports = __webpack_public_path__ + "img/pub3.55bd49ca.png";